module.exports = __webpack_public_path__ + "img/almadia.688baff2.jpg";